/*
* Copyright (C) 2018 The ontology Authors
* This file is part of The ontology library.
*
* The ontology is free software: you can redistribute it and/or modify
* it under the terms of the GNU Lesser General Public License as published by
* the Free Software Foundation, either version 3 of the License, or
* (at your option) any later version.
*
* The ontology is distributed in the hope that it will be useful,
* but WITHOUT ANY WARRANTY; without even the implied warranty of
* MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
* GNU Lesser General Public License for more details.
*
* You should have received a copy of the GNU Lesser General Public License
* along with The ontology.  If not, see <http://www.gnu.org/licenses/>.
*/

import { BigNumber } from 'bignumber.js';
import { ERROR_CODE } from './../error';
import { bigIntFromBytes, bigIntToBytes } from './../utils';

const SIZE = 8;
/**
 * Big positive integer base on BigNumber
 */
export default class BigInt {
    /**
     * Create BigInt from string
     * @param hex Byte string value
     */
    static fromHexstr(hex: string): BigInt {
        return new BigInt(bigIntFromBytes(hex));
    }

    value: string | number;
    ledgerCompatible: boolean;

    constructor(value: string | number, ledgerCompatible: boolean = true) {
        const bi = new BigNumber(value);
        if (!bi.isInteger()) {
            throw new Error(String(ERROR_CODE.INVALID_PARAMS));
        }
        this.value = value;
        this.ledgerCompatible = ledgerCompatible;
    }

    /**
     * Create hex string from BigInt
     */
    toHexstr(): string {
        let hex = bigIntToBytes(this.value);
        if (this.ledgerCompatible && (hex.length % 2 !== 0 || hex.length < 16)) {
            hex = hex + '0'.repeat(SIZE * 2 - hex.length);
        }
        return hex;
    }
}
